import { render, staticRenderFns } from "./UpdateDiscountStep.vue?vue&type=template&id=51e70ece&scoped=true&"
import script from "./UpdateDiscountStep.vue?vue&type=script&lang=js&"
export * from "./UpdateDiscountStep.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDiscountStep.vue?vue&type=style&index=0&id=51e70ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e70ece",
  null
  
)

export default component.exports